import { getCommonDateRangeWithPresetFilterLabel, getCommonDateRangeWithPresetFilterValue } from "../../../Utils/commonUtils";
import ChrCommonDateRange from "../../../../../utils/CustomObject/ChrCommonDateRange";

export const getValueToDisplay = (data) => {
  const selectedPreset = data.presets.find(preset => !!preset.selected);
  let label = (selectedPreset.canEdit ? selectedPreset.label : '');
  const value = getCommonDateRangeWithPresetFilterLabel({ dateFilter: { data: data }}, 'dateFilter').label;
  if(label && value)
    label = label + ': ';
  return label + value;
}

export const getSelectedValue = (data) => {
  getCommonDateRangeWithPresetFilterValue({ dateFilter: { data: data }}, 'dateFilter', 'dateFilter').dateFilter;
}

export const isValidData = (data) => {
  const selectedPreset = data.presets.find(preset => !!preset.selected);
  if(!selectedPreset.canEdit)
    return true;
  return selectedPreset.allowedFields.every(field => data[field]?.data?.value);
}

export const getEventDetailsForDateFilter = (hashDetail, options) => {
  const dateAndPresetString = getCommonDateRangeWithPresetFilterValue(hashDetail, options?.filterKey, 'dateRange');
  const dateRangeAndPreset = ChrCommonDateRange.getComponentsFromDateString(dateAndPresetString?.dateRange);

  if(dateRangeAndPreset){
    return {
      eventName: chrEventConstants.action.APPLY_DATE_FILTER,
      dateRange: [dateRangeAndPreset?.fromDate, dateRangeAndPreset?.toDate].join(datePickerTranslations.dateRangeSeparator),
      preset: dateRangeAndPreset?.preset,
      }
    }
  }
